import React from "react";
import { splitLinks } from "../../utils/linkify";

/**
 * Text whose URLs are clickable and open in a NEW TAB (2026-09-26). Used for
 * event notes. Splitting lives in `utils/linkify.js` so it is unit-tested
 * without the DOM. The click is stopped from propagating so a link inside a
 * popup that has its own click handling never also triggers that.
 */
export default function LinkifiedText({ text, linkStyle }) {
  return (
    <>
      {splitLinks(text).map((run, i) =>
        run.href ? (
          <a
            key={i}
            href={run.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ color: "inherit", textDecoration: "underline", ...linkStyle }}
          >
            {run.text}
          </a>
        ) : (
          <React.Fragment key={i}>{run.text}</React.Fragment>
        )
      )}
    </>
  );
}
